'use strict';

module.exports = {
    /**
     * Validate URL.
     *
     * @param {string} url - url for validation
     *
     * @return {boolean} validation result
     */
    validateUrl: function ( url ) {
        // eslint-disable-next-line
        return (/^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i).test(url);
    },

    /**
     * Assign new event to the current object.
     *
     * @param {string|Object} event - event name or object where the key is event name and value is handler
     * @param {Function} callback - function that will be executed when event was triggered
     */
    bind: function ( event, callback ) {
        var name;

        this.events || (this.events = {});

        if ( typeof event === 'object' ) {
            for ( name in event ) {
                this.bind(name, event[name]);
            }
        } else if ( typeof event === 'string' && typeof callback === 'function' ) {
            if ( this.events[event] === undefined ) {
                this.events[event] = [];
            }

            this.events[event].push(callback);
        }
    },

    /**
     * Trigger some event.
     *
     * @param {string} event - name of events which will be triggered
     * @param {*} data - data for transmission
     *
     * @return {Object[]} result set
     */
    trigger: function ( event, data ) {
        var results = [],
            self = this,
            result;

        if ( event !== undefined && this.events !== undefined && this.events[event] !== undefined ) {
            this.events[event].forEach(function ( ev ) {
                result = ev.call(self, data);

                if ( result !== undefined ) {
                    results.push(result);
                }
            });
        }

        return results;
    }
};
